module.exports = window["smartfireGutenberg"];